export const apikey=process.env.REACT_APP_API_KEY
export const url="https://api.spoonacular.com"
export const backendurl=process.env.REACT_APP_API_URL